import { useEffect, useState } from 'react';

/** Delays propagating a rapidly changing value, e.g. search input. */
export const useDebouncedValue = <T,>(value: T, delay = 180): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
